// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_5eb7737cbbb94613db12073cb5e3ade1"};